<div mat-dialog-content>
  <mat-form-field class="statusFormfield">
    <mat-label>Status</mat-label>
    <mat-select #statusValue (valueChange)="getSelectedStatus($event)">
      @for (items of statusValues; track items) {
        <mat-option [value]="items.value">{{ items.text }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="statusFormfield">
    <mat-label>Record</mat-label>
    <mat-select (valueChange)="getSelectedRecord($event)">
      @for (records of recordsArray; track records; let i = $index) {
        <mat-option [value]="records.amountPaidId">
          <span>{{ records.paymentDate }} {{ ' ' }}</span>
          <span>&#8377;{{ records.totalPaid }}{{ ' ' }}</span>
          <span>{{ records.referenceNo }}</span>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mt-btn class="field-submit-btn statusFormfield" (click)="updatePaymentStatus()">
    Submit
  </mt-btn>
</div>
